@if (branding.loadState() === 'not-found') {
<app-branding-not-found />
} @else {
<router-outlet />
}
